<template>
  <div id="business" class="body">
    <Top />

    <div role="main" class="main">
      <section class="page-header page-header-classic page-header-sm">
        <div class="container">
          <div class="row">
            <div class="col-md-8 order-2 order-md-1 align-self-center p-static">
              <h1 data-title-border>事業内容</h1>
            </div>
            <div class="col-md-4 order-1 order-md-2 align-self-center">
              <ul class="breadcrumb d-block text-md-right">
                <li><router-link to="/index">Home</router-link></li>
                <li class="active">会社案内</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section class="company-layout">
        <CompanyNav active-key="business" />

        <div class="info-grid">
          <article class="info-panel">
            <p class="page-kicker">ICT Solutions</p>
            <h3>ICTソリューション事業</h3>
            <p class="lead-text">SESにより磨き抜かれた技術とナレッジにより、高い専門性を有するエキスパートが製品、金融システム開発を行います。</p>
            <ul>
              <li>受託サービス</li>
              <li>WEBサイト構築、運用、保守</li>
              <li>システム設計・開発・運用支援業務</li>
              <li>ECシステム構築</li>
            </ul>
          </article>

          <article class="info-panel">
            <p class="page-kicker">Offshore Development</p>
            <h3>オフショア開発事業</h3>
            <p class="lead-text">長年のオフショア開発から培ったノウハウと経験を活かし、高品質かつ業務に最適化したソリューションをご提供します。</p>
            <ul>
              <li>オフショアコーディネータ</li>
              <li>オフショアパートナー認定支援</li>
              <li>オフショア推進・全般管理</li>
              <li>オンサイト作業支援</li>
            </ul>
          </article>
        </div>
      </section>
    </div>

    <Foot />
  </div>
</template>

<script>
import Top from '@/components/top';
import Foot from '@/components/foot';
import CompanyNav from '@/components/companyNav';

export default {
  name: 'business',
  components: {
    Top,
    Foot,
    CompanyNav,
  },
};
</script>
